import { COLOR } from '../config/tokens'

// The kiosk draws its markers with emoji; webOS Signage has no colour emoji font, so
// the board draws the same markers as inline SVG (24 grid, stroke 2, round caps).
// Same icons, same labels, same placement — build-guide §4.

interface IconProps {
  size: number
  color?: string
}

export function ChiliIcon({ size, color = COLOR.jasper }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
      <path d="M17 4c0 3-2 5-3 6" />
      <path d="M14 10c-1 6-6 10-10 10 2-6 6-10 10-10z" />
      <path d="M14 10c3 0 5-2 5-5" />
    </svg>
  )
}

export function LeafIcon({ size, color = COLOR.leaf }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 20c0-9 6-15 16-16-1 10-7 16-16 16z" />
      <path d="M4 20c4-5 8-8 12-10" />
    </svg>
  )
}

/** Crescent — Halal. */
export function CrescentIcon({ size, color = COLOR.plum }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
      <path d="M15 3a9 9 0 1 0 6 15.5A7 7 0 1 1 15 3z" />
    </svg>
  )
}

/** Star — Popular. */
export function StarIcon({ size, color = COLOR.plum }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill={color} stroke="none">
      <path d="M12 2.5l2.9 6.1 6.6.8-4.9 4.6 1.3 6.6L12 17.4l-5.9 3.2 1.3-6.6L2.5 9.4l6.6-.8z" />
    </svg>
  )
}

/** Sparkle — New. */
export function SparkleIcon({ size, color = COLOR.plum }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill={color} stroke="none">
      <path d="M12 2l2 6 6 2-6 2-2 6-2-6-6-2 6-2z" />
      <path d="M19 14l1 3 3 1-3 1-1 3-1-3-3-1 3-1z" />
    </svg>
  )
}

/** No-symbol — Sold out. */
export function NoSymbolIcon({ size, color = COLOR.white }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth={2.4} strokeLinecap="round">
      <circle cx="12" cy="12" r="9" />
      <path d="M5.6 5.6l12.8 12.8" />
    </svg>
  )
}
